<script lang="ts">
export const ICON_PATHS = {
  more: [
    'M6 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
    'M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
    'M18 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
  ],
  'arrow-right': ['M4 12h16M14 6l6 6-6 6'],
  dashboard: ['M4 6a2 2 0 0 1 2-2h4l2 2h6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6Z'],
  check: ['M5 13l4 4L19 7'],
  'check-double': ['M2 13l4 4L16 7', 'M9.5 16.5l.5.5L22 7'],
  home: ['M3 11.5 12 4l9 7.5', 'M5 10v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-9'],
  save: [
    'M5 5a2 2 0 0 1 2-2h8l4 4v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5Z',
    'M9 3v5h6V3M8 13h8v8H8v-8Z',
  ],
  export: ['M12 4v12m0 0 4-4m-4 4-4-4M4 20h16'],
  import: ['M12 16V4m0 0 4 4m-4-4-4 4M4 20h16'],
  close: ['M6 6l12 12M18 6L6 18'],
  copy: [
    'M9 9h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2Z',
    'M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1',
  ],
  help: [
    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z',
    'M9.5 9a2.5 2.5 0 1 1 3.4 2.3c-.8.4-1.4 1-1.4 1.9v.3',
    'M12 17h.01',
  ],
  trash: [
    'M3 6h18',
    'M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6',
    'M10 11v6M14 11v6',
    'M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2',
  ],
  load: [
    'M3 7a2 2 0 0 1 2-2h4l2 2h6a2 2 0 0 1 2 2v1H7a2 2 0 0 0-2 1.8L4 18l-1-9V7Z',
    'M4.5 18 6 10.5h14L18.5 18a2 2 0 0 1-2 1.5H6.5a2 2 0 0 1-2-1.5Z',
  ],
  warning: [
    'M12 9v3.5m0 3h.01M10.6 3.6 2.9 17a1.5 1.5 0 0 0 1.3 2.2h15.6a1.5 1.5 0 0 0 1.3-2.2L13.4 3.6a1.5 1.5 0 0 0-2.8 0Z',
  ],
  plus: ['M5 12h14', 'M12 5v14'],
  eye: ['M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z', 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z'],
  minus: ['M5 12h14'],
  pencil: ['M4 20h4L18.5 9.5a2 2 0 0 0-2.83-2.83L5 17.5V20Z', 'M13.5 6.5l3 3'],
  refresh: [
    'M21 3v6h-6',
    'M3 12a9 9 0 0 1 15-6.7L21 9',
    'M3 21v-6h6',
    'M21 12a9 9 0 0 1-15 6.7L3 15',
  ],
  settings: [
    'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
    'M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09a1.65 1.65 0 0 0-1.08-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09a1.65 1.65 0 0 0 1.51-1.08 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z',
  ],
  campaigns: [
    'M3 5a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5Z',
    'M7 13h10M7 17h6',
  ],
  eraser: [
    'M7 21h14',
    'M16.5 4.5 21 9a2 2 0 0 1 0 2.8l-8.6 8.6a2 2 0 0 1-2.8 0l-4.5-4.5a2 2 0 0 1 0-2.8l8.6-8.6a2 2 0 0 1 2.8 0Z',
    'M9 9l6 6',
  ],
  // Status-condition glyphs (Status Engine), drawn in the shared 24x24 box.
  'status-prone': ['M12 5v14', 'M5 12l7 7 7-7'],
  'status-restrained': ['M6 11h12v9H6z', 'M9 11V8a3 3 0 0 1 6 0v3'],
  'status-obscured': ['M3 9h14', 'M7 13h14', 'M3 17h11'],
  'status-invisible': [
    'M9.9 5.1A9.8 9.8 0 0 1 12 5c6.5 0 10 7 10 7a18 18 0 0 1-3 3.8',
    'M6.6 6.6A17 17 0 0 0 2 12s3.5 7 10 7a9.6 9.6 0 0 0 4.4-1',
    'M4 4l16 16',
  ],
  'status-combat-advantage': [
    'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z',
    'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z',
    'M12 12h.01',
  ],
  // Weapon-category silhouettes, drawn in the shared 24x24 box.
  'cat-light-blade': ['M5 19 17 7M17 7l2-2M17 7l-2.5-.5M17 7l.5 2.5'],
  'cat-heavy-blade': ['M5 19 17 7M17 7l2.5-1M17 7l-3-1M4 18l2 2M5 19l1.5-1.5M5 19l-1.5 1.5'],
  'cat-axe': [
    'M14 5 19 10M14 5c-2 1-4.5 3.5-6 6L4 19l3-1c2.5-1.5 5-4 6-6M14 5c2-1 4 .5 4 2.5S16 11 14 9',
  ],
  'cat-polearm': ['M4 20 18 6M18 6l2-2M18 6l-2.5 0M18 6l0 2.5'],
  'cat-impact': ['M9 19 16 8M16 8a3 3 0 1 0-4-4 3 3 0 0 0 4 4Z'],
  'cat-bow': ['M7 4c-4 4-4 12 0 16M7 4l11 8L7 20M18 12h.01'],
  'cat-crossbow': ['M3 14h12M9 8v12M5 14a4 4 0 0 1 8 0M19 9l2 5-2 5'],
  'cat-sling': ['M6 14a5 5 0 1 0 8-6M14 8l4-4m0 0h-3m3 0v3'],
  // Quality-tier pips: filled (active) tiers drawn as a tight inner stroke,
  // empty tiers as a plain outline. simple=1, war=2, superior=3.
  'group-simple': [
    'M4 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 11.7a.3.3 0 1 0 0 .6.3.3 0 0 0 0-.6',
    'M12 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5',
    'M20 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5',
  ],
  'group-war': [
    'M4 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 11.7a.3.3 0 1 0 0 .6.3.3 0 0 0 0-.6',
    'M12 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M12 11.7a.3.3 0 1 0 0 .6.3.3 0 0 0 0-.6',
    'M20 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5',
  ],
  'group-superior': [
    'M4 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 11.7a.3.3 0 1 0 0 .6.3.3 0 0 0 0-.6',
    'M12 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M12 11.7a.3.3 0 1 0 0 .6.3.3 0 0 0 0-.6',
    'M20 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M20 11.7a.3.3 0 1 0 0 .6.3.3 0 0 0 0-.6',
  ],
  // Leave/exit a campaign (door + outward arrow).
  leave: ['M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8', 'M10 12h11m0 0-4-4m4 4-4 4'],
  // Residence icons (Fase 2 — INC-012)
  cloud: ['M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z'],
  device: ['M4 5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5Z', 'M9 17h6'],
  lock: ['M8 11V7a4 4 0 1 1 8 0v4M6 11h12v10H6V11Z', 'M12 15v2'],
  // B5c turn order (ADR-079): the GM's target toggle and the "hidden from players" row state.
  target: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z', 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z', 'M12 1v4M12 19v4M1 12h4M19 12h4'],
  'eye-off': ['M3 3l18 18', 'M10.6 5.1A10 10 0 0 1 12 5c6.5 0 10 7 10 7a17 17 0 0 1-3.2 4', 'M6.2 6.3C3.6 8 2 12 2 12s3.5 7 10 7c1.8 0 3.3-.5 4.6-1.2', 'M9.9 9.9a3 3 0 0 0 4.2 4.2'],
  // B5d: the Scene hint disclosure (what Live and By post mean).
  info: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z', 'M12 11v5', 'M12 8h.01'],
  // B6 (Q29): the campaign row is a link; the chevron marks it.
  'chevron-right': ['M9 6l6 6-6 6'],
} as const

export type IconName = keyof typeof ICON_PATHS
</script>

<script setup lang="ts">
// Shared SVG icon set, selected by name. Centralizes the inline icons that
// used to be duplicated across IconButton/WarningTooltip call sites.
withDefaults(
  defineProps<{
    name: IconName
    size?: string
    strokeColor?: string
    strokeWidth?: string
  }>(),
  {
    size: 'h-5 w-5',
    strokeColor: 'currentColor',
    strokeWidth: '2',
  },
)
</script>

<template>
  <svg
    :viewBox="name === 'warning' ? '0 0 24 22' : '0 0 24 24'"
    fill="none"
    :stroke="strokeColor"
    :stroke-width="strokeWidth"
    :class="size"
  >
    <path
      v-for="d in ICON_PATHS[name]"
      :key="d"
      stroke-linecap="round"
      stroke-linejoin="round"
      :d="d"
    />
  </svg>
</template>
